import formStyles from './styles/Forms.module.scss';
import Page from './layouts/Page';
import { AuthenticateRequest, AuthService } from '../api/auth';
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setToken } from '../store/slices/uiSlice';
import { Grid, Typography, TextField } from '@material-ui/core';
import { SubmitHandler, useForm } from 'react-hook-form';
import LoadingSpinner from '../dashboard/components/LoadingSpinner';

const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);

  const { register, handleSubmit, setError, formState } = useForm<AuthenticateRequest>();

  const login: SubmitHandler<AuthenticateRequest> = (data) => {
    setIsLoading(true);

    AuthService.login(data)
      .then((res) => {
        dispatch(setToken(res.data));
        history.push('/dashboard');
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.status === 400) {
          setError('email', { type: 'manual', message: '' });
          setError('password', { type: 'manual', message: '' });
        }
      });
  };

  return (
    <Page>
      {isLoading && <LoadingSpinner attachToRoot />}
      <h1>Login</h1>
      <p>Please enter your credentials below to login to system</p>
      <Grid component="form" onSubmit={handleSubmit(login)} noValidate container flexDirection="column" sx={{ marginTop: '1rem' }}>
        <Grid item container spacing={2}>
          <Grid item xs md={6}>
            <TextField
              label="Email Address"
              {...register('email', {
                required: { value: true, message: 'Please enter your email address' },
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Invalid email address',
                },
              })}
              helperText={formState.errors.email?.message}
              error={!!formState.errors.email}
            />
          </Grid>
        </Grid>

        <Grid item container spacing={2}>
          <Grid item xs={6} md={6}>
            <TextField
              label="Password"
              InputProps={{ type: 'password' }}
              {...register('password', { required: { value: true, message: 'Please enter your password' } })}
              helperText={formState.errors.password?.message}
              error={!!formState.errors.password}
            />
          </Grid>
        </Grid>

        <Grid item container spacing={2} alignItems="center">
          <Grid item xs={12} md={6} sx={{ mt: 1 }}>
            <Typography variant="body2" align="right">
              <Link to="/forget-password">Forget password?</Link>
            </Typography>
          </Grid>
        </Grid>

        {!!formState.errors.email && !!formState.errors.password && (
          <Grid item alignItems="center" sx={{ mt: 2 }}>
            <Typography variant="body2" color="red">
              Invalid email address or password. Please try again.
            </Typography>
          </Grid>
        )}

        <Grid item container sx={{ mb: 3 }}>
          <Grid item xs={6}>
            <button disabled={isLoading} type="submit" className={formStyles.submit} style={{ width: '100%' }}>
              Login
            </button>
          </Grid>
        </Grid>
      </Grid>
    </Page>
  );
};

export default Login;
